/* CANI header: side menu with tabs, scroll state, header height variable. */
(() => {
  const root = document.documentElement;
  const header = document.querySelector('[data-ds-header]');
  if (!header || header.dataset.dsReady) return;
  header.dataset.dsReady = '1';

  /* ---------- header height + scroll state ---------- */
  const section = header.closest('.shopify-section');
  const setHeight = () => {
    const h = header.offsetHeight;
    /* Resting height is kept by the section so the page does not move when the bar gets compact. */
    if (section && (!header.classList.contains('is-scrolled') || window.innerWidth < 750)) {
      section.style.setProperty('--ds-hdr-rest', h + 'px');
    }
    root.style.setProperty('--header-height', h + 'px');
    root.style.setProperty('--header-bottom-position', h + 'px');
    root.style.setProperty('--ds-header-h', h + 'px');
  };
  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
      ticking = false;
    });
  };
  setHeight();
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', setHeight);
  if ('ResizeObserver' in window) new ResizeObserver(setHeight).observe(header);

  /* Dawn's cart notification calls header.reveal() when it exists. */
  header.reveal = () => {};

  /* ---------- side menu ---------- */
  const menu = document.querySelector('[data-ds-menu]');
  const openBtn = header.querySelector('[data-ds-menu-open]');
  if (!menu || !openBtn) return;
  const panel = menu.querySelector('.ds-menu__panel');
  let lastFocus = null;

  const focusables = () =>
    Array.from(panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(
      (el) => el.offsetParent !== null
    );

  const open = () => {
    lastFocus = document.activeElement;
    menu.hidden = false;
    requestAnimationFrame(() => {
      menu.classList.add('is-open');
      document.body.classList.add('ds-lock');
      openBtn.setAttribute('aria-expanded', 'true');
      const current = panel.querySelector('[role="tab"][aria-selected="true"]') || focusables()[0];
      if (current) current.focus({ preventScroll: true });
    });
  };
  const close = () => {
    menu.classList.remove('is-open');
    document.body.classList.remove('ds-lock');
    openBtn.setAttribute('aria-expanded', 'false');
    const done = () => {
      if (!menu.classList.contains('is-open')) menu.hidden = true;
    };
    panel.addEventListener('transitionend', done, { once: true });
    setTimeout(done, 450);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };

  openBtn.addEventListener('click', open);
  menu.querySelectorAll('[data-ds-menu-close]').forEach((el) => el.addEventListener('click', close));
  document.addEventListener('keydown', (e) => {
    if (!menu.classList.contains('is-open')) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key === 'Tab') {
      const list = focusables();
      if (!list.length) return;
      const first = list[0];
      const last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  /* ---------- tabs ---------- */
  const tabs = Array.from(menu.querySelectorAll('[data-ds-tab]'));
  const select = (tab) => {
    tabs.forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      const p = document.getElementById(t.getAttribute('aria-controls'));
      if (p) p.hidden = !on;
    });
  };
  tabs.forEach((tab, i) => {
    tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;
    tab.addEventListener('click', () => select(tab));
    tab.addEventListener('keydown', (e) => {
      /* In RTL the visual "next" tab is to the left. */
      const rtl = getComputedStyle(tab).direction === 'rtl';
      let to = null;
      if (e.key === 'ArrowLeft') to = rtl ? i + 1 : i - 1;
      if (e.key === 'ArrowRight') to = rtl ? i - 1 : i + 1;
      if (e.key === 'Home') to = 0;
      if (e.key === 'End') to = tabs.length - 1;
      if (to === null) return;
      e.preventDefault();
      const t = tabs[(to + tabs.length) % tabs.length];
      select(t);
      t.focus();
    });
  });

  /* Open the tab that holds the current page. */
  const current = menu.querySelector('.ds-menu__list [aria-current="page"]');
  if (current) {
    const list = current.closest('[role="tabpanel"]');
    const tab = list && tabs.find((t) => t.getAttribute('aria-controls') === list.id);
    if (tab) select(tab);
  }
})();
